import React from 'react';
import _ from 'lodash';

import {
  Button,
  Grid,
  Paper as MuiPaper,
  styled,
  Typography
} from '@mui/material';
import {
  authService as ifAuthService,
  fields,
  Form,
  LoadingOverlay,
  validationUtil
} from 'iron-forge-react-modules';
import {
  activityTemplates,
  appFormUtil,
  authUtil,
  routeDirectory
} from 'modules';
import {
  useNavigate,
  useParams
} from 'react-router-dom';

import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const Paper = styled(MuiPaper)(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: 512,
  marginLeft: 'auto',
  marginRight: 'auto'
}));

const RootGrid = styled(Grid)({
  minHeight: '100vh',
  alignItems: 'center'
});

const FormGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1)
}));

const ButtonGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'space-between'
});

const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();

export const RegisterActivity: React.FC = () => {
  const params = useParams<{ inviteCode: string; }>();
  const tuple = dataService.useQuery(params.inviteCode ?? '');
  const [fnRegister, registerTuple] = dataService.useRegister(params.inviteCode ?? '');

  const navigate = useNavigate();
  const form = useForm<types.IFormState>({
    defaultValues: {
      email: '',
      password: '',
      confirmPassword: ''
    }
  });



  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      const {
        password,
        confirmPassword,
        email
      } = appFormUtil.trimFormStateValues(formState);

      if (password !== confirmPassword) {
        alert("Passwords do not match.");
        return;
      }
      try {

        await fnRegister({
          email,
          password,
          phoneNumber: ''
        });

        let done = false;
        do {
          try {
            const code = prompt("Enter the verification code from your email");
            if (code) {
              await ifAuthService.confirmRegisterCode(code);
              done = true;
              await authUtil.logIn({ email, password });
            }

          } catch (err) {
            if (err instanceof Error) {
              alert(err.message);
            }
          }
        } while (!done);

      } catch (err) {
        if (err instanceof Error) {
          if (err.message === 'EMAIL_EXISTS') {
            alert("That email is already in use.");
          } else {
            alert(err.message);
          }
        }
      }
    },
    [
      fnRegister
    ]
  );



  function handleClickHaveAnAccount() {
    navigate(routeDirectory.auth.logIn.path());
  }



  const elForm = (
    <Form.FC onSubmit={form.handleSubmit(processSubmit)}>
      <FormGrid container>
        <Grid
          item
          xs={12}>
          <ControlledTextField
            formControl={form.control}
            isRequired
            label="Email"
            extraValidationRules={{}}
            fieldKey="email" />
        </Grid>

        <Grid
          item
          xs={12}>
          <ControlledTextField
            type="password"
            isRequired
            formControl={form.control}
            label="Password"
            extraValidationFunctions={[
              validationUtil.isValidPassword
            ]}
            fieldKey="password" />
        </Grid>

        <Grid
          item
          xs={12}>
          <ControlledTextField
            type="password"
            isRequired
            formControl={form.control}
            label="Confirm Password"
            extraValidationFunctions={[
              validationUtil.isValidPassword
            ]}
            fieldKey="confirmPassword" />
        </Grid>

        <ButtonGrid
          item
          xs={12}>
          <Button onClick={handleClickHaveAnAccount}>
            Have an account?
          </Button>

          <Button
            variant="contained"
            type="submit">
            Register
          </Button>
        </ButtonGrid>
      </FormGrid>
    </Form.FC>
  );

  return (
    <activityTemplates.BaseActivityTemplate.FC onlyAllowLoggedOutUsers>
      <LoadingOverlay.FC active={registerTuple.isLoading} />

      {!tuple.loading && (
        <RootGrid
          container
          spacing={3}>
          <Grid
            item
            xs={6}>
            <Paper>
              <Typography variant="h2">Register an account</Typography>

              {_.isNil(tuple.data.invite) && (
                <Typography>Invite not found</Typography>
              )}

              {!_.isNil(tuple.data.invite) && tuple.data.invite.isClaimed ? (
                <Typography>Invite already claimed</Typography>
              ) : elForm}
            </Paper>
          </Grid>

          <Grid
            item
            xs={6}>

          </Grid>
        </RootGrid>
      )}

    </activityTemplates.BaseActivityTemplate.FC>
  );
};
